import PointerInteraction from 'ol/interaction/Pointer';
import MapBrowserEventType from 'ol/MapBrowserEventType';

import { LocationFinderEvent } from 'cadenza/map/location-finder/location-finder-event';

export class LocationFinderInteraction extends PointerInteraction {

  constructor (map, { layerFilter } = {}) {
    super({ map, handleEvent: event => this._handleEvent(event) });
    this._map = map;
    this._layerFilter = layerFilter;
    this._selectedFeature = null;
  }

  setActive (active) {
    super.setActive(active);
    if (!active) {
      this.dispatchEvent(new LocationFinderEvent('locationFinder.clearFlyoutHandler', null));
    }
  }

  /**
   * Handles the map browser event and highlights Location Finder features on hover and selects them on pointerdown.
   *
   * @param {MapBrowserEvent} mapBrowserEvent - Map browser event.
   * @return {boolean} `false` to stop event propagation.
   */
  _handleEvent (mapBrowserEvent) {
    // After pointerdown was handled by the Location Finder interaction, pointerup and click should also stop event propagation to prevent other active interactions from handling that event.
    // Location Finder interaction should react already on pointerdown, because Location Finder jquery ui autocomplete closes its menu on pointerdown and Location Finder features are cleaned up.
    if (this._discardNextClickEvent && (mapBrowserEvent.type === MapBrowserEventType.POINTERUP || mapBrowserEvent.type === MapBrowserEventType.CLICK)) {
      return false; // stop event propagation
    }
    if (this._discardNextClickEvent && (mapBrowserEvent.type === MapBrowserEventType.SINGLECLICK || mapBrowserEvent.type === MapBrowserEventType.DBLCLICK)) {
      this._discardNextClickEvent = false;
      return false; // stop event propagation
    }

    if (mapBrowserEvent.type === MapBrowserEventType.POINTERDOWN) {
      const locationFinderFeatureUnderMouse = this._getFirstLocationFinderFeatureAtPixel(mapBrowserEvent.pixel);
      if (locationFinderFeatureUnderMouse) {
        this._discardNextClickEvent = true;
        const event = new LocationFinderEvent('locationFinder.click', locationFinderFeatureUnderMouse);
        this.dispatchEvent(event);
        return false; // stop event propagation
      }
    }

    if (mapBrowserEvent.type === MapBrowserEventType.POINTERMOVE) {
      const locationFinderFeatureUnderMouse = this._getFirstLocationFinderFeatureAtPixel(mapBrowserEvent.pixel);
      if (locationFinderFeatureUnderMouse) {
        if (!this._selectedFeature || this._selectedFeature !== locationFinderFeatureUnderMouse) {
          this._selectedFeature = locationFinderFeatureUnderMouse;
          const event = new LocationFinderEvent('locationFinder.hover', locationFinderFeatureUnderMouse);
          this.dispatchEvent(event);
          return false; // stop event propagation
        }
      } else if (this._selectedFeature) {
        this._selectedFeature = null;
      }
    }

    return super.handleEvent(mapBrowserEvent);
  }

  _getFirstLocationFinderFeatureAtPixel (pixel) {
    return this._map.getFeaturesAtPixel(pixel, { layerFilter: this._layerFilter })[0] || null;
  }

}
